// TMOS Issue Entity Configuration
// Date: November 15, 2025
// Purpose: Entity definition for FlexibleCRUDTable

import { EntityDefinition } from '@/types/crud';

export const issueEntity: EntityDefinition = {
  name: 'issues',
  displayName: 'Issues',
  displayNameSingular: 'Issue',
  apiEndpoint: '/issues',
  idField: 'id',
  nameField: 'title',
  fields: [
    {
      key: 'title',
      name: 'title',
      label: 'Title',
      type: 'text',
      required: false,
      hidden: true
    },
    {
      key: 'description',
      name: 'description',
      label: 'Description',
      type: 'textarea',
      required: true
    },
    {
      key: 'issue_category_id',
      name: 'issue_category_id',
      label: 'Category',
      type: 'select',
      placeholder: 'Select category',
      optionsEndpoint: '/generic/issue_categories',
      optionsValueField: 'id',
      optionsLabelField: 'name',
      order: 3,
      hidden: true // Hidden in table, use category_name instead
    },
    {
      key: 'urgency',
      name: 'urgency',
      label: 'Urgency',
      type: 'select',
      options: [
        { value: 'LOW', label: 'Low' },
        { value: 'MEDIUM', label: 'Medium' },
        { value: 'HIGH', label: 'High' },
        { value: 'CRITICAL', label: 'Critical' }
      ],
      defaultValue: 'MEDIUM'
    },
    {
      key: 'impact',
      name: 'impact',
      label: 'Impact',
      type: 'select',
      options: [
        { value: 'LOW', label: 'Low' },
        { value: 'MEDIUM', label: 'Medium' },
        { value: 'HIGH', label: 'High' },
        { value: 'CRITICAL', label: 'Critical' }
      ],
      defaultValue: 'MEDIUM'
    },
    {
      key: 'status',
      name: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'OPEN', label: 'Open' },
        { value: 'IN_PROGRESS', label: 'In Progress' },
        { value: 'RESOLVED', label: 'Resolved' },
        { value: 'CLOSED', label: 'Closed' }
      ],
      defaultValue: 'OPEN'
    },
    {
      key: 'privacy',
      name: 'privacy',
      label: 'Privacy',
      type: 'select',
      options: [
        { value: 'PRIVATE', label: 'Private' },
        { value: 'PUBLIC', label: 'Public' }
      ],
      defaultValue: 'PRIVATE'
    },
    {
      key: 'target_type',
      name: 'target_type',
      label: 'Target Type',
      type: 'select',
      required: true,
      options: [
        { value: 'PLATFORM', label: 'Platform' },
        { value: 'TENANT_ADMIN', label: 'Tenant Admin' },
        { value: 'PROGRAM', label: 'Program' },
        { value: 'PROJECT', label: 'Project' },
        { value: 'USER', label: 'User' },
        { value: 'TRANSFORMATION', label: 'Transformation' }
      ]
    },
    {
      key: 'target_id',
      name: 'target_id',
      label: 'Target ID',
      type: 'text',
      hidden: true
    },
    {
      key: 'assigned_to',
      name: 'assigned_to',
      label: 'Assigned To',
      type: 'text',
      hidden: true
    },
    {
      key: 'created_at',
      name: 'created_at',
      label: 'Created At',
      type: 'datetime',
      readOnly: true,
      hidden: true
    },
    {
      key: 'updated_at',
      name: 'updated_at',
      label: 'Updated At',
      type: 'datetime',
      readOnly: true,
      hidden: true
    },
    {
      key: 'category_name',
      name: 'category_name',
      label: 'Category',
      type: 'text',
      readOnly: true,
      hidden: false
    }
  ],
  tableColumns: [
    { key: 'title', label: 'Title', sortable: true, render: (v: any) => { const t = String(v || ''); return t.length > 140 ? `${t.slice(0, 140)}...` : t; } },
    { key: 'description', label: 'Description', sortable: true, render: (v: any) => { const t = String(v || ''); return t.length > 140 ? `${t.slice(0, 140)}...` : t; } },
    { key: 'category_name', label: 'Category', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'creator_name', label: 'Raised by', sortable: true },
    { key: 'target_type', label: 'Target Type', sortable: true },
    { key: 'created_at', label: 'Created', sortable: true, render: (v: any) => v ? new Date(v).toLocaleDateString() : '' }
  ]
};


